export default [
  {
    path: '/search-gudang',
    name: 'search-gudang',
    component: () => import('@/views/pages/kompack/gudang/SearchGudangkuIFrame.vue'),
    meta: {
      resource: 'Cari Gudang',
      action: 'manage',
    },
    children: [
      {
        path: 'detail/:id',
        name: 'detail-gudang-search',
        component: () => import('@/views/pages/kompack/gudang/detail/Detail.vue'),
      },
      {
        path: 'detail/:id/cek-biaya-fulfillment',
        name: 'cek-biaya-fulfillment',
        component: () => import('@/views/pages/kompack/gudang/detail/cek-biaya-fulfillment/CekBiayaFulfillment.vue'),
      },
    ],
  },
  {
    path: '/search-gudang/detail/submission/:id',
    name: 'detail-gudang-search',
    component: () => import('@/views/pages/kompack/gudang/AjukanBerlanggananGudang.vue'),
    meta: {
      resource: 'Cari Gudang',
      action: 'manage',
    },
  },
  {
    path: '/ajukan-inbound',
    name: 'ajukan-inbound',
    component: () => import('@/views/pages/kompack/gudang/ajukan-inbound/ajukaninbound.vue'),
    meta: {
      resource: 'Ajukan Inbound',
      action: 'manage',
    },
  },
  {
    path: '/integrasi-marketplace',
    name: 'integrasi-marketplace',
    component: () => import('@/views/pages/kompack/gudang/integrasi-marketplace/IntegrasiMarketplacePage.vue'),
    meta: {
      resource: 'Integrasi Marketplace',
      action: 'manage',
    },
    children: [
      {
        path: '/integrasi-marketplace/mapping-product/:shopId',
        name: 'integrasi-marketplace-mapping-product',
        component: () => import('@/views/pages/kompack/gudang/integrasi-marketplace/products-mapping/ProductsMappingPage.vue'),
        children: [
          {
            path: '/integrasi-marketplace/mapping-product/:shopId/mapping-variants/:productId',
            name: 'integrasi-marketplace-mapping-variants',
            component: () => import('@/views/pages/kompack/gudang/integrasi-marketplace/products-mapping/variants-mapping/VariantsMappingPage.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/marketplace-transaction',
    name: 'marketplace-transaction',
    component: () => import('@/views/pages/kompack/gudang/marketplace-transaction/MarketplaceTransactionPage.vue'),
    meta: {
      resource: 'Marketplace Transaction',
      action: 'manage',
    },
  },
  {
    path: '/riwayat-pengajuan',
    name: 'riwayat-pengajuan',
    component: () => import('@/views/pages/kompack/gudang/riwayat-pengajuan/RiwayatPengajuan'),
    meta: {
      resource: 'Riwayat Pengajuan',
      action: 'manage',
    },
  },
  {
    path: '/detail-riwayat-inbound/:id',
    name: 'detail-riwayat-inbound',
    component: () => import('@/views/pages/kompack/gudang/riwayat-pengajuan/DetailInbound'),
    meta: {
      resource: 'Riwayat Pengajuan',
      action: 'manage',
    },
  },
  {
    path: '/detail-riwayat-tambah-product/:id',
    name: 'detail-riwayat-tambah-product',
    component: () => import('@/views/pages/kompack/gudang/riwayat-pengajuan/DetailTambahProduct'),
    meta: {
      resource: 'Riwayat Pengajuan',
      action: 'manage',
    },
  },
  {
    path: '/detail-riwayat-berlangganan/:id',
    name: 'detail-riwayat-berlangganan',
    component: () => import('@/views/pages/kompack/gudang/riwayat-pengajuan/DetailBerlangganan'),
    meta: {
      resource: 'Riwayat Pengajuan',
      action: 'manage',
    },
  },
  {
    path: '/riwayat-pengajuan/produk/:id',
    name: 'detail-riwayat-pengajuan-produk',
    component: () => import('@/views/pages/kompack/gudang/riwayat-pengajuan/produk/DetailRiwayatPengajuanProduk'),
    meta: {
      resource: 'Riwayat Pengajuan',
      action: 'manage',
    },
  },
  {
    path: '/integrasi-marketplace/success',
    name: 'integrasi-marketplace-success',
    component: () => import('@/views/pages/kompack/gudang/integrasi-marketplace/IntegratedSuccesfullyPage.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: false,
    },
  },
  {
    path: '/integrasi-marketplace/error',
    name: 'integrasi-marketplace-error',
    component: () => import('@/views/pages/kompack/gudang/integrasi-marketplace/ErrorIntegrationPage.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: false,
    },
  },
]
